<div class="date-range-component">
	<div class="date-component">
		<mat-form-field class="flex-grow">
			<mat-label *ngIf="label">{{ label }}</mat-label>
			<mat-label *ngIf="!label" i18n="Label@@filterInputDateRangeLabel">Date range</mat-label>
			<mat-date-range-input [formGroup]="form" [rangePicker]="picker" >
				<input matStartDate (dateChange)="changeDatesWithDebounce()" [formControlName]="controlName" placeholder="Start date" i18n-placeholder="Start Date Placeholder@@filterInputDateRangeStartPlaceholder"/>
				<input matEndDate (dateChange)="changeDatesWithDebounce()" [formControlName]="secondControlName" placeholder="End date" i18n-placeholder="End Date Placeholder@@filterInputDateRangeEndPlaceholder"/>
			</mat-date-range-input>
			<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
			<mat-date-range-picker #picker></mat-date-range-picker>
		</mat-form-field>

		<button *ngIf="showClearButton" mat-flat-button class="clear-button" color="tertiary" (click)="clearForm()">
			<ng-container i18n="Clear@@filtersClearDateRangeButton:Clear">
				Clear Date
			</ng-container>
		</button>
	</div>
	<ng-container *ngIf="form.controls?.[controlName]?.hasError('matStartDateInvalid')">
		<mat-error>Invalid start date</mat-error>
	</ng-container>
	<ng-container *ngIf="form.controls?.[secondControlName]?.hasError('matEndDateInvalid')">
		<mat-error>Invalid end date</mat-error>
	</ng-container>
</div>
